import { store } from "../store";

let ApiList = store.getState().apiList.apiList;

export const msalConfig = {
    auth: {
        clientId: ApiList.clientId,
        authority: ApiList.authority,
        redirectUri: ApiList.getRedirectURI,
        //postLogoutRedirectUri: ApiList.authority + "/oauth2/v2.0/logout"
        //postLogoutRedirectUri: ApiList.getPostLogoutRedirectUri
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    authApiEndpoint: ApiList.getAuthUser
};